var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',[_c('v-system-bar',{attrs:{"color":"intern"}},[_vm._v(" Letzte Änderungen"),_c('v-spacer'),_vm._v(" "+_vm._s(this.itemsFiltered.length)+" Einträge ")],1),_c('ChangeLogTable',{attrs:{"items":_vm.itemsFiltered,"showCoursePart":true,"showPerson":true,"items-per-page":50}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }